import dynamic from 'next/dynamic'
import Head from 'next/head'
import Header from '../../components/Header';
import LargeCTA from '../../components/LargeCTA';
import Accordion from 'react-bootstrap/Accordion';
import CTA from '../../components/CTA';
import YoastSEO from '../../components/YoastSEO';
import Image from "next/legacy/image";
import Map from "../../components/Map";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { decode } from 'html-entities';

import 'lightbox.js-react/dist/index.css'
import {SlideshowLightbox, initLightboxJS} from 'lightbox.js-react'

import { client } from '../../lib/apollo';
import { GET_HEADER_OPTIONS,
  GET_FOOTER_OPTIONS, GET_PRESERVE, GET_NEWS_PRESERVES } from '../../queries/queries';

import { useState } from "react";
import Script from 'next/script'
import { formatPostDate } from "../../utilities/dateFormat"
import { useEffect } from "react";

import { RouteChangeListener } from '../../components/OptinMonsterEmbed';

const DynamicFooter = dynamic(() => import('../../components/Footer'))

export default function PreservesPage({ pageData }) {
  let [isOpen, setIsOpen] = useState(false);

  const [activeAccordion, setActiveAccordion] = ('');
  const toggleAccordion = (e, randomNumber) => {
      e.preventDefault();
      
      if(activeAccordion === randomNumber){
          setActiveAccordion('');
      } else {
          setActiveAccordion(randomNumber);
      }
  };

  const headerData = pageData?.headerData;
  const footerData = pageData?.footerData;

  const preserve = pageData?.preserve;
  const cta = pageData?.footerData?.data?.siteOptions?.siteOptions?.cta[0];

  const closestPreserves = pageData?.closestPreserves;
  const news = pageData?.newsPreserves?.data?.newsPreserves?.edges[0]?.node.posts?.nodes[0];

  const seoData = pageData?.preserve.seo;

  let newGallery = [];
  
  preserve.preserves?.gallery?.map((element) => {
    let newElement = {...element};

    if(newElement.caption){
        newElement.caption = decode(newElement?.caption?.toString().replace(/<[^>]*>?/gm, ''));
    }

    if(newElement.alt){
        newElement.alt = newElement?.alt?.toString().replace(/<[^>]*>?/gm, '');
    }

    if(newElement.description){
        newElement.caption += ' - ' + decode(newElement.description.toString().replace(/<[^>]*>?/gm, ''));
        newElement.alt += ' - ' + decode(newElement.description.toString().replace(/<[^>]*>?/gm, ''));
    }

    newGallery.push(newElement);
  });

  useEffect(() => {
    initLightboxJS(process.env.NEXT_LIGHTBOX_KEY, "Individual");
  });

  return (
      <div>
        <Script defer={true}>
          {`(function (w, d, s, l, i) {
                    w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', 'GTM-KJ842L9');`}
        </Script>
        <Script defer={true}>
          {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1908777585816939');fbq('track','PageView');
        `}
        </Script>
        <YoastSEO
          page={seoData}
          MetaRenderElement={Head}
          meta={<>
            <meta name="MobileOptimized" content="width" />
            <meta name="HandheldFriendly" content="True"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0" />
            <title>Natural Lands</title>
            <link rel="icon" href="/assets/favicon/favicon.ico"></link>
          </>}
        ></YoastSEO>
        <Header header={headerData}></Header>
        <main>
          <div id="content" role="main">
            {
              preserve && (
                <>
                    <div id="single-visit-header-container" className='container-fluid'>
                        <div className='container'>
                            <h1>{preserve.title}</h1>
                            <div dangerouslySetInnerHTML={{__html: preserve.preserves.headerContent}}></div>
                        </div>
                    </div>
                    <div id="single-visit-image-container" className='container-fluid'>
                        <Image
                            src={`${preserve.featuredImage.node.sourceUrl}`}
                            layout='fill'
                        />
                        {
                            preserve.preserves.imageCaption && (
                                <div id="single-visit-image-caption-container">
                                    <a data-tooltip-id="fmv-tooltip" data-tooltip-content={`${preserve.preserves.imageCaption}`}>
                                        <img width={24} height={24} src="/assets/images/icon-photo-credit.svg" alt="Tooltip" />
                                    </a>
                                    <ReactTooltip openOnClick={true} id="fmv-tooltip"></ReactTooltip>
                                </div>
                            )
                        }
                    </div>
                    {
                      preserve.preserves.displayAlertBar && (
                        <div id="single-visit-alert-bar-container" className='container-fluid'>
                          {
                            preserve.preserves.alertBarLink && (
                              <a href={`${preserve.preserves.alertBarLink}`} className='custom-link'>
                                <div className='container'>
                                  <div>
                                    <div>
                                      <span className='icon-alert'></span>
                                    </div>
                                    <div>
                                      <p>{preserve.preserves.alertBarContent}</p>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            )
                          }
                          {
                            !preserve.preserves.alertBarLink && (
                              <div className='container'>
                                <div>
                                  <div>
                                    <span className='icon-alert'></span>
                                  </div>
                                  <div>
                                    <p>{preserve.preserves.alertBarContent}</p>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      )
                    }
                    <div id="single-visit-content-container" className='container'>
                      <div>
                          <div dangerouslySetInnerHTML={{__html: preserve.preserves.description}}></div>
                          <div>
                            <div>
                              {
                                preserve.preserves.physicalAddress && (
                                  <div id="single-visit-address">
                                    <p className='title'>
                                      Address
                                    </p>
                                    <div dangerouslySetInnerHTML={{__html: preserve.preserves.physicalAddress}}></div>
                                    <Map address={preserve.preserves.physicalAddress} />
                                  </div>
                                )
                              }
                              {
                                preserve.preserves.visitorHours && (
                                  <div id="single-visit-hours">
                                    <p className='title'>
                                      Visitor Hours
                                    </p>
                                    <p dangerouslySetInnerHTML={{__html: preserve.preserves.visitorHours}}></p>
                                  </div>
                                )
                              }
                              {
                                preserve.preserves.trailMap && (
                                  <div id="single-visit-map">
                                    <a className='custom-link' href={`${preserve.preserves.trailMap}`} target='_blank'>
                                      <div>
                                        <span className='icon-download'></span>
                                      </div>
                                      <div>
                                        Trail Map
                                      </div>
                                    </a>
                                  </div>
                                )
                              }
                              {
                                preserve.preserveFeatures.nodes && preserve.preserveFeatures.nodes.length>0 && ( 
                                  <div id="single-visit-features">
                                      <p className='title'>
                                        Features
                                      </p>
                                      {
                                        preserve.preserveFeatures.nodes.map((item, index) => (  
                                            <div>
                                                <div>
                                                <Image
                                                    src={`${item.preserveFeature.icon.sourceUrl}`}
                                                    width={24}
                                                    height={24}
                                                />
                                                </div>
                                                <div>
                                                  <p>{item.name}</p>
                                                </div>
                                            </div>
                                        ))
                                      }
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </div>
                    </div>
                    {
                      preserve.preserves.accordions && (
                        <div id="single-visit-accordions-container" className='container'>
                          {
                            preserve.preserves.accordionContent && (
                              <div dangerouslySetInnerHTML={{__html: preserve.preserves.accordionContent}}></div>
                            )
                          }
                          {
                            preserve.preserves.accordions.length && (
                                <Accordion defaultActiveKey="0" flush>
                                  {
                                      preserve.preserves.accordions.map( ( item, innerIndex ) =>{
                                          return (
                                              <Accordion.Item eventKey={innerIndex}>
                                                  <Accordion.Header>
                                                      <div>
                                                          <span className='icon-plus'></span>
                                                      </div>
                                                      <div>
                                                          <h4>{item.title}</h4>
                                                      </div>
                                                  </Accordion.Header>
                                                  <Accordion.Body>
                                                      <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                                                  </Accordion.Body>
                                              </Accordion.Item>
                                          )
                                      })
                                  }  
                              </Accordion>
                            )
                          }
                        </div>
                      )
                    }
                    {
                      preserve.preserves.gallery && (
                        <div id="single-visit-gallery-container" className='container-fluid'>
                          <div>
                            <div>
                              <div>
                                  <div dangerouslySetInnerHTML={{__html: preserve.preserves.galleryContent}}></div>
                                  <button onClick={() => {setIsOpen(true)}} className='button red'>
                                      View Gallery
                                  </button>
                              </div>
                            </div>
                            {
                              preserve.preserves.galleryBackgroundImage && (
                                <div>
                                  <div className='gallery-background-image'>
                                      <Image
                                          src={`${preserve.preserves.galleryBackgroundImage.sourceUrl}`}
                                          layout='fill'
                                      />
                                  </div>
                                  <div>
                                    <SlideshowLightbox 
                                      lightboxIdentifier="lightbox1"
                                      framework="next" 
                                      images={newGallery} 
                                      open={isOpen}
                                      showThumbnails={true}
                                      captionStyle={{color: "#d9d9d9"}}
                                      onClose={() =>{setIsOpen(false)}}
                                    >
                                      {newGallery.map((image) => (
                                          <Image
                                            src={image.src}
                                            data-lightboxjs="lightbox1"
                                            quality={100}
                                            layout='fill'
                                            alt={image.alt}
                                          />
                                      ))}
                                    </SlideshowLightbox>
                                  </div>
                                </div>
                              )
                            }
                            {
                              !preserve.preserves.galleryBackgroundImage && (
                                <div>
                                    <SlideshowLightbox 
                                      lightboxIdentifier="lightbox1"
                                      framework="next" 
                                      images={newGallery} 
                                      open={isOpen}
                                      showThumbnails={true}
                                      captionStyle={{color: "#d9d9d9"}}
                                      onClose={() =>{setIsOpen(false)}}
                                    >
                                      {newGallery.map((image) => (
                                          <Image
                                            src={image.src}
                                            data-lightboxjs="lightbox1"
                                            quality={100}
                                            layout='fill'
                                            alt={image.alt}
                                          />
                                      ))}
                                    </SlideshowLightbox>
                                  </div>
                              )
                            }
                          </div>
                        </div>
                      )
                    }
                    {
                      closestPreserves.length && (
                        <div id="single-visit-closest" className='container xsmall-container'>
                          <h2>places nearby</h2>
                          <div>
                            {
                              closestPreserves.map((item, index) => (  
                                <div key={index}>
                                  <a href={`${item.redirect ? item.redirect : '/visit/' + item.url}`} className='custom-link'>
                                    {
                                      item.image && (
                                        <div className='image-wrapper'>
                                          <Image
                                                src={`${item.image}`}
                                                layout='fill'
                                                quality={100}
                                            />
                                        </div>
                                      )
                                    }
                                    <div className='visit-content'>
                                      <h2 className='preserve-title' dangerouslySetInnerHTML={{__html: item.title}}></h2>
                                      <p>{item.location}</p>
                                      <p>{item.acreage}</p>
                                    </div>
                                  </a>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      )
                    }
                    {
                      news && (
                        <div id="single-visit-news" className='container'>
                          <h2>news from the preserve</h2>
                          <div>
                            <div>
                              {
                                news.featuredImage?.node && news?.featuredImage?.node?.mediaDetails?.sizes?.length && (
                                  <Image
                                    src={`${news.featuredImage.node.mediaDetails.sizes[0].sourceUrl}.webp`}
                                    srcSet={news.featuredImage.node.mediaDetails.srcSet}
                                    sizes={news.featuredImage.node.mediaDetails.sizes}
                                    layout='fill'
                                    alt={news.featuredImage.node.altText}
                                    title={news.featuredImage.node.title}
                                  />
                                )
                              }
                              {
                                news?.featuredImage?.node && !news?.featuredImage?.node?.mediaDetails?.sizes?.length && (
                                  <Image
                                    src={`${news.featuredImage?.node.sourceUrl}`}
                                    srcSet={news.featuredImage?.node.mediaDetails?.srcSet}
                                    sizes={news.featuredImage?.node.mediaDetails?.sizes}
                                    height={
                                      340
                                    }
                                    quality={100}
                                    width={530}
                                    alt={news.featuredImage?.node.altText}
                                    title={news.featuredImage?.node.title}
                                  />
                                )
                              }
                          </div>
                          <div>
                            <h4>{news.title}</h4>
                            <div className="news-list-details">
                              <p>{formatPostDate(news.date)}</p>
                            </div>
                            {
                                news.excerpt && (
                                    <div dangerouslySetInnerHTML={{__html: news.excerpt}}></div>
                                )
                            }
                            <a aria-label={`${news.title}`} href={`${news.uri}`} className="button red">
                              continue reading
                            </a>
                          </div>
                          </div>
                        </div>
                      )
                    }
                </>
              )
            }
            <CTA
              cta={cta}
            ></CTA>
          </div>
          <Script defer={true}>
            {`(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,32897,23154);
    <!-- / OptinMonster -->`}
            </Script>
            <RouteChangeListener/>
        </main>
        <DynamicFooter footer={footerData}></DynamicFooter>
      </div>
  )
}

export async function getStaticProps({ params }){
  const slug = params.uri;

  const response = await client.query({
    query: GET_PRESERVE,
    variables: { slug: slug }
  });

  const preserve = response?.data?.preservesBy; 

  const responseClosestPreserves = await fetch(`${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/naturallands/v1/preserves/find?id=${preserve.databaseId}`);
  const responseClosestPreservesData = await responseClosestPreserves.json();

  const responseNews = await client.query({
    query: GET_NEWS_PRESERVES,
    variables: { slug: slug }
  });

  const footerData = await client.query({
    query: GET_FOOTER_OPTIONS
  });

  const headerData = await client.query({
    query: GET_HEADER_OPTIONS
  });

  return {
    props: {
      pageData: {
        footerData: footerData,
        preserve: preserve,
        newsPreserves: responseNews,
        closestPreserves: responseClosestPreservesData,
        headerData: headerData
      }
    },
    revalidate: 45,
  }
}

export async function getStaticPaths(){
    const paths = []
    return {
        paths,
        fallback: 'blocking'
    }
}